export interface SensorMarkerOrderValue {
  missing: boolean;
  value: number | null | undefined;
}

const hasValue = (value: number | null | undefined) =>
  value !== null && value !== undefined && value !== 0;

export const compareSensorMarkerOrder = (
  left: SensorMarkerOrderValue,
  right: SensorMarkerOrderValue
) => {
  const missingOrder = Number(!left.missing) - Number(!right.missing);
  if (missingOrder !== 0) {
    return missingOrder;
  }

  const valueOrder = Number(hasValue(left.value)) - Number(hasValue(right.value));
  if (valueOrder !== 0) {
    return valueOrder;
  }

  return (left.value || 0) - (right.value || 0);
};

const comparePrecipMarkerValues = (
  left: number | null,
  right: number | null
) =>
  compareSensorMarkerOrder(
    { missing: false, value: left },
    { missing: false, value: right }
  );

export default comparePrecipMarkerValues;